import { createSelector } from "@reduxjs/toolkit";
import { systemErrorsAdapter } from "../statusAPI";
import { useApi } from "../apiContext";
const useSystemErrorsSelectors = ()=>{
    // Selectors for the normalized system_errors data
    const { statusApi } = useApi();
    const selectStatus = statusApi.endpoints.getStatus.select();
    const selectSystemErrorsData = createSelector(selectStatus, (status)=>status?.data?.system_errors ?? systemErrorsAdapter.getInitialState());
    const { selectIds: selectSystemErrorMsgs } = systemErrorsAdapter.getSelectors(selectSystemErrorsData);
    return {
        selectSystemErrorMsgs
    };
};
export { useSystemErrorsSelectors };
